import { Button, Stack, TextField, FormControl, InputLabel, Divider, Select, MenuItem, CircularProgress } from '@mui/material'
import React, { useState, useRef, useEffect } from 'react'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { api } from '../../../../redux/api';
import { newTemplateActions } from '../../../../redux/slices/newTemplateSlice';

function NtwXSDTemplate() {
  const { t } = useTranslation();
  const [rootElement, setRootElement] = useState('');
  const [rootElementOptions, setRootElementOptions] = useState([])
  const [xsdFile, setXSDFile] = useState('')
  const [isXSDValid, setIsXSDValid] = useState(false)
  const [loading, setLoading] = useState(false)
  const error = useRef();
  const fileBrowser = useRef();
  const dispatch = useDispatch();
  const { account } = useSelector((state) => state.queryParams);
  const currentScreen = useSelector(state => state.treeData.currentScreen)
  const { XSDTemplateData: data } = useSelector((state) => state.newTemplate)

  const handleChange = (key, e) => {
    if (key === 'ROOT_ELEMENT') {
      dispatch(newTemplateActions.setXSDTemplateData({ ...data, rootElement: e.target.value }))
    }

  }
  const handleUploadClick = async (e) => {
    const file = e.target.files[0];
    if(!file) return;
    setXSDFile(file.name)
    const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.')

    let fileInfo;
    try {
      const reader = new FileReader();
      reader.onload = (e) => {
        fileInfo = e.target.result;
      };
      reader.readAsText(file);
      setLoading(true)
      let formData = new FormData();
      formData.append("file", file);
      const response = await dispatch(
        api.endpoints.getXSDRoots.initiate({
          account: account,
          data: formData,
          template_type: currentScreen === "inbound" ? "INBOUND" : "",
        })
      )
      if(response.error){
        throw new Error(response.error.message || t("BOX_MSG_GENERAL_ERROR"));
      }
      if (response?.data.current_state === "SUCCESS" && response?.data.data.length > 0) {
        setLoading(false)
        setIsXSDValid(true);
        setRootElementOptions(response?.data?.data);
        setRootElement(response?.data?.data[0]?.title);
        dispatch(newTemplateActions.setXSDTemplateData({ fileInfo, rootElement: response?.data?.data[0]?.title }))
        dispatch(newTemplateActions.setTemplateName(fileNameWithoutExtension))

      } else {
        setLoading(false)
        error.current.textContent = response.data.message || t('ERR_PARSING_XSD').split('\\')[0];
        dispatch(newTemplateActions.setXSDTemplateData(""));
        dispatch(newTemplateActions.setTemplateName(""))

      }
    } catch (err){
         setLoading(false)
         error.current.textContent = err.message || "An unknown error occurred"
    }
  };
  const rootElementDropdownOption = rootElementOptions?.map((option, key) => (
    <MenuItem key={key} value={option.title}>{option.title}</MenuItem>
  ));
  useEffect(() => {
    dispatch(newTemplateActions.setIsFormData(true))
  }, [])
  return (
    <>
      <Stack spacing={'8px'}>
        <div className='flex'>
          <TextField
            className='width-100'
            label={'Choose XSD File'}
            variant='outlined'
            size='small'
            value={xsdFile}
            onChange={() => error.current.textContent = ""}
          ></TextField>
          <input
            style={{ display: 'none' }}
            type='file'
            ref={fileBrowser}
            onChange={(e) => {
              // setXSDFile(e.target.value)
              error.current.textContent = ""
              setRootElement('')
              setIsXSDValid(false)
              handleChange('FILE_PATH', e)
              handleUploadClick(e)
            }}
          >
          </input>
          <Button
            variant="outlined"
            size="small"
            disableElevation
            className="margin-left-4"
            disabled={loading}
            sx={{
              width: "40px",
              padding: "4px 8px",
              minWidth: "40px",
            }}
            onClick={() => {
              fileBrowser.current.click();
            }}>
            { loading ? <CircularProgress size={"20px"} color='primary'/> : <DriveFolderUploadIcon fontSize="small" />}
          </Button>
         </div> 
        <div>
          <p className="error" ref={error}></p>
        </div>
        <FormControl size="small" variant="outlined">
          <InputLabel id="validationDropdownLabel">
            {t("LBL_ROOT_ELEM_NM")}
          </InputLabel>
          <Select
            className="width-100"
            MenuProps={{
              PaperProps: {
                sx: {
                  maxHeight: 300,
                },
              },
            }}
            labelId="validationDropdownLabel"
            id="validationDropdown"
            disabled={!isXSDValid}
            value={rootElement || ''}
            onChange={(e) => {
              setRootElement(e.target.value);
              handleChange("ROOT_ELEMENT", e);
            }}
            label={t("LBL_ROOT_ELEM_NM")}>
            {rootElementDropdownOption}
          </Select>
        </FormControl>
      </Stack>
    </>
  )
}

export default NtwXSDTemplate